// Dependencies
import styled from 'styled-components';

const BlogPostStyles = styled.div`
  height: calc(100% - 2.5rem);
  margin: 0 0 2.5rem;
  padding: 1rem 0.688rem;
  border: 0.06rem solid var(--color-swiss-coffee);
  break-inside: avoid;
  text-align: left;
  color: var(--color-charcoal);

  .inner {
    height: 100%;
    background-color: #fff;
    border: ${(props) =>
      props?.large ? '0' : '0.06rem solid var(--color-swiss-coffee)'};

    & > .top {
      display: block;

      .featured-img {
        position: relative;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &.filter {
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            pointer-events: none;
            background-color: var(--color-bark);
            opacity: 0.4;
          }
        }
      }
    }

    & > .bottom {
      padding: 2.125rem 1.25rem 1.938rem;

      .meta {
        display: flex;
        margin: 0 0 1.5rem;

        .top,
        .bottom {
          display: block;
        }

        .top .profile-photo {
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 3.5rem;
          height: 3.5rem;
          margin: 0 1.125rem 0 0;
          overflow: hidden;
          border-radius: 100%;
          background-color: var(--color-white);

          img {
            border-radius: 100%;
          }

          .icon {
            width: 1.375rem;
            height: auto;
            border-radius: 0;
          }

          &.has-icon {
            background-color: var(--color-sand);
            border-color: var(--color-sand);
          }
        }

        .bottom {
          display: flex;
          flex-direction: column;

          .name,
          .article-info {
            padding: 0;
            color: var(--color-bark);
          }

          .name {
            font-style: italic;
            line-height: 1.5;
            margin: 0 0 0.5rem;
          }

          .article-info {
            margin: 0;
            font-size: 0.75rem;
          }
        }
      }

      .categories {
        margin: 0 0 1.25rem;
        padding: 0;
        list-style: none;

        .category {
          a {
            font-size: 0.813rem;
            font-weight: var(--font-weight-medium);
            color: var(--color-bark);
            text-transform: uppercase;
          }
        }
      }

      .separator {
        margin: 1.25rem 0;
      }

      .title-wrap {
        width: 100%;

        &:hover,
        &:focus {
          color: var(--color-bark);
        }
      }

      .title,
      .excerpt {
        color: var(--color-charcoal);
      }

      .title {
        font-weight: var(--font-weight-light);
      }

      .excerpt {
        font-size: 0.938rem;
      }
    }
  }

  @media (min-width: 768px) {
    padding: 1.25rem;

    .inner {
      & > .top {
        margin: 0 0 1.688rem;

        .featured-img {
          display: flex;
          justify-content: center;
          align-items: center;
          height: ${(props) => (props?.large ? '25rem' : '15.5rem')};
          background-color: var(--color-sand);

          img {
            object-position: top;
          }

          .logo {
            max-width: 50%;
            object-fit: unset;
          }
        }
      }

      & > .bottom {
        display: flex;
        flex-wrap: wrap;
        padding: 0.5rem 1.5rem 1rem;

        .meta,
        .categories {
          width: 100%;
        }

        .meta {
          margin: 0 0 1.5rem;
        }

        .title {
          max-width: 75%;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .inner {
      & > .bottom {
        position: relative;
        padding-left: ${(props) => (props?.large ? '11rem' : '1.25rem')};

        .meta {
          position: ${(props) => (props?.large ? 'absolute' : 'initial')};
          left: 0;
          order: 1;
          margin-top: -3.438rem;
          display: block;
          width: ${(props) => (props?.large ? '10rem' : '100%')};
          padding: 0 ${(props) => (props?.large ? '1.25rem' : 0)};

          .top,
          .bottom {
            width: 100%;
          }

          .top .profile-photo {
            margin: 0 0 0.5rem;
            border: 0.5rem solid #fff;
          }

          .bottom {
            ${(props) =>
              !props?.large &&
              `
              display: flex;
              justify-content: space-between;
            `}

            .name {
              padding: 0 0.25rem 0 0;
            }

            .article-info {
              padding: 0.4rem 0 0;
              white-space: nowrap;

              .pipe {
                display: ${(props) => (props?.large ? 'none' : 'inline-block')};
                margin: 0 0.25rem;
              }

              .date {
                display: ${(props) =>
                  props?.large ? 'block' : 'inline-block'};
              }
            }
          }
        }

        .categories {
          order: 2;
        }

        .title-wrap {
          order: 3;
        }
      }
    }
  }
`;

export default BlogPostStyles;
